import { render, staticRenderFns } from "./PorEquipe.vue?vue&type=template&id=6a1a0922&scoped=true"
import script from "./PorEquipe.vue?vue&type=script&lang=js"
export * from "./PorEquipe.vue?vue&type=script&lang=js"
import style0 from "./styles.scss?vue&type=style&index=0&id=6a1a0922&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a1a0922",
  null
  
)

export default component.exports